export const environment = {
    production: false,
    siriusCdnBaseUrl: '',
    siriusHeaderVersion: '/latest',
    siriusNavbarVersion: '/latest',
    siriusQuickNavVersion: '/latest',
    siriusFooterVersion: '/latest',
    cdnBaseUrl: '',
    customCodeEndpoint: '/tdp-tenant-custom-code',
    customCodeVersion: '',
    assetsLibraryEndpoint: '/tdp-assets-library',
    assetsLibraryVersion: '',
    catalogsEndpoint: '/si-registry/api/v1/catalogs',
    usersEndpoint: '/tdm-users/public/current-user',
    dciAuthBaseUrl: '',
    dciClientId: '',
    glassboxLibraryUrl: '',
    changeImpersonationUrl: 'https://techdirect.dell.com/Portal/SupportProcessor.aspx',
    tdpNavBarUrl: '',
    hostUrl: ''
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aXJvbm1lbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Vudmlyb25tZW50cy9lbnZpcm9ubWVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHO0lBQ3ZCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLGdCQUFnQixFQUFFLEVBQUU7SUFDcEIsbUJBQW1CLEVBQUUsU0FBUztJQUM5QixtQkFBbUIsRUFBRSxTQUFTO0lBQzlCLHFCQUFxQixFQUFFLFNBQVM7SUFDaEMsbUJBQW1CLEVBQUUsU0FBUztJQUM5QixVQUFVLEVBQUUsRUFBRTtJQUNkLGtCQUFrQixFQUFFLHlCQUF5QjtJQUM3QyxpQkFBaUIsRUFBRSxFQUFFO0lBQ3JCLHFCQUFxQixFQUFFLHFCQUFxQjtJQUM1QyxvQkFBb0IsRUFBRSxFQUFFO0lBQ3hCLGdCQUFnQixFQUFFLDhCQUE4QjtJQUNoRCxhQUFhLEVBQUUsZ0NBQWdDO0lBQy9DLGNBQWMsRUFBRSxFQUFFO0lBQ2xCLFdBQVcsRUFBRSxFQUFFO0lBQ2Ysa0JBQWtCLEVBQUUsRUFBRTtJQUN0QixzQkFBc0IsRUFBRSwwREFBMEQ7SUFDbEYsWUFBWSxFQUFFLEVBQUU7SUFDaEIsT0FBTyxFQUFFLEVBQUU7Q0FDZCxDQUFDIn0=